
<style lang="scss" scoped>
img {
  width: 10px;
  height: 10px;
}
.az-button {
  display: inline-block;
  i {
    font-size: 12px;
    // color: $text-regular;
  }
  .el-button--medium {
    padding: 11px;
  }

  .el-button--small {
    padding: 9px;
  }

  .el-button--mini {
    padding: 7px;
  }

  // 样式
  // 默认样式
  background-color: #fff;
  border: 0 none;
  > button {
    background-color: #fff;
    border: 1px solid $border-color-base;
    border-radius: 3px;
    &:hover {
      background-color: $color-primary-light;
      border-color: $color-primary;
    }
  }

  .iconfont {
    color: $color-primary;
  }

  .primary {
    background-color: $color-btn-primary;
    border-color: $color-btn-primary;
    .iconfont {
      color: $color-btn-icon;
    }
    &:hover {
      background-color: $color-primary;
      border-color: $color-primary;
      .iconfont {
        color: #fff;
      }
    }
  }
  .refresh {
    .iconfont {
      color: $color-primary;
    }
    &:hover {
      background-color: $bg-color-base;
      border-color: $color-primary;
    }
  }
  .clear {
    background-color: #61BF96;
    border-color: #61BF96;
    .iconfont {
      color: #fff;
    }
    &:hover {
         background-color: $color-success;
      border-color: $color-success;
      .iconfont {
        color: #fff;
      }
    }
  }
  .success {
    background-color: $color-success-light;
    border-color: $color-success-light;
    .iconfont {
      color: $color-success;
    }
    &:hover {
      background-color: $color-success;
      border-color: $color-success;
      .iconfont {
        color: #fff;
      }
    }
  }

  .danger {
    .iconfont {
      color: $color-danger;
    }
    &:hover {
      background-color: $bg-color-base;
      border-color: $color-danger;
    }
  }

  .warinig {
    background-color: $color-warning-light;
    border-color: $color-warning-light;
    .iconfont {
      color: $color-warning;
    }
    &:hover {
      background-color: $color-warning;
      border-color: $color-warning;
      .iconfont {
        color: #fff;
      }
    }
  }

  &:active {
    opacity: 0.6;
  }
}
.az-button + .az-button {
  margin-left: 4px;
}
.el-button + .az-button {
  margin-left: 10px;
}
.az-button + .el-button {
  margin-left: 10px;
}
</style>
<template>
  <div class="az-button">
    <el-tooltip class="item" effect="dark" :content="content"
      :open-delay="600"
      placement="top" :disabled="infoNotShow">
      <el-button :size="size"
        :class="[curTypeInfo.type, 'el-button--primary']">
        <img v-if="isLoading" src="/static/img/gif_01.gif" alt="加载">
        <i v-else :class="['iconfont', curTypeInfo.icon]"></i>
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'az-button',
  props: {
    type: {
      type: String,
      default: 'search'
    },
    infoNotShow: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: '按钮'
    },
    size: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      typePreSet: {
        'search': {
          icon: 'az-app-searching',
          type: 'primary'
        },
        'user': {
          icon: 'az-app-person-fill',
          type: 'primary'
        },
        'group': {
          icon: 'az-app-folder',
          type: 'primary'
        },

        'order': {
          icon: 'oaicon-xiangqing',
          type: 'primary'
        },

        'auth': {
          icon: 'az-app-auth-code',
          type: 'primary'
        },

        'device': {
          icon: 'az-app-device',
          type: 'primary'
        },
        'detail': {
          icon: 'az-app-xiangqing',
          type: 'primary'
        },
        'rule': {
          icon: 'az-app-guizeguanli',
          type: 'primary'
        },
        'login': {
          icon: 'az-app-notes1',
          type: 'primary'
        },

        'speed': {
          icon: 'az-app-sudu',
          type: 'primary'
        },
        'edit': {
          icon: 'oaicon-editer',
          type: 'primary'
        },

        'editBase': {
          icon: 'oaicon-base-edit',
          type: 'primary'
        },

        'delete': {
          icon: 'az-app-shanchu',
          type: 'danger'
        },
        'refresh': {
          icon: 'oaicon-refresh',
          type: 'refresh'
        },
        'delete-primary': {
          icon: 'oaicon-shanchu',
          type: 'primary'
        },
        'authcode': {
          icon: 'az-app-auth-code-send',
          type: 'primary'
        },
        'record': {
          icon: 'oaicon-dayin',
          type: 'primary'
        },
        'spend-money': {
          icon: 'oaicon-fukuan',
          type: 'primary'
        },
        'clear-url': {
          icon: 'oaicon-qingchu',
            type: 'primary'
        }

      }
    };
  },
  computed: {
    curTypeInfo() {
      const type = this.type;
      const preSet = this.typePreSet[type];
      if (preSet) return preSet;
      return {
        type,
        icon: 'search'
      };
    }
  },

};
</script>
